/* eslint-disable import/no-unresolved */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Browsers can emit this harmless notification while Ant Design recalculates a
// responsive layout. Keep the development overlay from treating it as an app error.
if (process.env.NODE_ENV === 'development') {
    window.addEventListener('error', (event) => {
        if (
            event?.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
            event?.message?.includes('ResizeObserver loop limit exceeded')
        ) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);

    window.addEventListener('unhandledrejection', (event) => {
        if (
            event?.reason?.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
            event?.reason?.message?.includes('ResizeObserver loop limit exceeded')
        ) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
